"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCardContentType = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../../../../../Text/Text");
/** This is a very small wrapper around the Text element
 * It allows us to have the correct Text variant, and to
 * place the element correctly in the grid in ActionCardHeader
 */
const ActionCardContentType = ({ contentType, headingLevel = "h3" }) => {
    return (react_1.default.createElement(Text_1.Text, { as: headingLevel, skinny: true, variant: "label" }, contentType));
};
exports.ActionCardContentType = ActionCardContentType;
exports.ActionCardContentType.displayName = "ActionCardContentType";
//# sourceMappingURL=ActionCardContentType.js.map